import { Component, inject } from '@angular/core';
import { MedicationGroup } from '../models/medication-group';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-meds-of-interest',
  templateUrl: './meds-of-interest.component.html',
  styleUrls: ['./meds-of-interest.component.scss'],
  standalone: false
})
export class MedsOfInterestComponent {
  authService = inject(AuthService);

  selectedMedication: MedicationGroup | null = null;
  showAddItems = false;
  onRowSelected(med: MedicationGroup): void {
    this.selectedMedication = med;
  }

  goBackToTable(): void {
    this.selectedMedication = null;
    this.showAddItems = false;
  }

  openAddItems(): void {
    this.showAddItems = true;
  }

  getUserRole(){
    if (this.authService.user === undefined || this.authService.user === null){
      return ''
    }
    else {return this.authService.user.role;
    }
  }

  canEdit(): boolean {
    return this.getUserRole() === 'DDPD';
  }
}
